// App-wide DOM-level behaviors that apply to every instance of a native
// control, regardless of which React component renders it.
// Wired up once from index.js so no individual component needs to opt in.

// Globally restrict date input year to 4 digits.
// Native date values are always "YYYY-MM-DD"; over-typing produces e.g. "55555-02-05".
export function enableFourDigitYearDateInputs() {
  document.addEventListener(
    "input",
    (e) => {
      const el = e.target;
      if (el.tagName !== "INPUT" || el.type !== "date" || !el.value) return;
      const parts = el.value.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4);
        el.value = parts.join("-");
        el.dispatchEvent(new Event("input", { bubbles: true }));
      }
    },
    true // capture phase — runs before React handlers
  );
}
